import slick from 'slick-carousel'

let sliderSlick = () => {

    let module = {},
        slider,
        sliderAutoplay,
        sliderInfinite,
        canSlide,
        init = () => {

            slider = $('[data-slick]');
            if (!slider.length) {
                return;
            }

            slider.each(function () {
                var $this = $(this);
                sliderAutoplay = (typeof $this.attr("data-slick-autoplay") == "undefined") ? false : true;
                /**
                 * todo - change to false if nedefined
                 */
                sliderInfinite = (typeof $this.attr("data-slick-infinite") == "undefined") ? true : true;
                canSlide = (typeof $this.attr("data-slick-slide") == "undefined") ? false : true;

                if ($this.attr("id") == 'main-slick-slider-2') {

					$(window).scroll(function (event) {
						var scroll = $(window).scrollTop();
						var winH = $(window).height();
						var sliderH = $("#main-slick-slider-2").height();

						var maxScale = 1.15;

						if (scroll < sliderH && sliderH > 0) {
							var scale = 1+(scroll * (maxScale-1)/sliderH);
							$(".sliderbg").css('transform', 'scale('+scale+')');
						} else if (scroll > sliderH) {
							$(".sliderbg").css('transform', 'scale('+maxScale+')');
						} else {
							$(".sliderbg").css('transform', 'scale(1)');
						}
					});

                    $this.on('init reInit afterChange',function(event, slick, direction) {
                        var _slide_num = slick.currentSlide + 1;
                        $("#slider_title_"+_slide_num+" h2").text("");
						if ($("#slider_title_"+_slide_num).length > 0) {
							animateTitleByChar($("#slider_title_"+_slide_num), $);
						}
                        // console.log("Slide zamenjan");
                    });
                    $this.on('beforeChange',function(event, slick, direction) {
						var _slide_num = slick.currentSlide + 1;
                        $("#slider_title_"+_slide_num+" h2").css("opacity",0);
                        // console.log("Slide zamenjan");
                    });
                }

                $this.slick({
                    infinite: sliderInfinite,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    autoWidth: false,
                    speed: 800,
                    autoplay: sliderAutoplay,
                    autoplaySpeed: 6000,
                    centerPadding: 0,
                    lazyLoad: 'progressive',
                    fade: (canSlide ? false : true),
                    cssEase: (canSlide ? 'ease' : 'linear'),
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    pauseOnDotsHover: false,
                    draggable: false,
                    swipe: true,
                });

            });

function animateTitle(el, $) {
	var delayInt = 0.1;
	var fadeSec = 2;

	var text = el.find(".orig_title").text();
	var lines = text.split("\n");
	var _html = '';

	var delay = 0.1;
	for (var i = 0; i < lines.length; i++) {
		var words = lines[i].split(" ");
		_html += '<div class="l">';
		for (var j = 0; j < words.length; j++) {
			_html += '<span class="w" style="animation:wordAnim ' + fadeSec + 's ease-in-out ' + delay + 's forwards;">';
			_html += words[j] + ' </span>';
			delay += (words[j].length/1.6 * delayInt);
		}
		_html += '</div>';
	}
	el.find("h2").html(_html);
}

function animateTitleByChar(el, $) {
    if ( $(".orig_title a").length > 0) {
        var html = el.find(".orig_title").html();
        el.find("h2").html(html).css("opacity","0");
        el.find("h2").animate({
            opacity: 1.0,
        }, 1000, function() {
            // Animation complete.
        });
    } else {
            var delayInt = 0.07;
            var fadeSec = 1;

            var text = el.find(".orig_title").text();
            var lines = text.split("\n");
            var _html = '';

            var delay = 0.1;
            for (var i = 0; i < lines.length; i++) {
                var chars = lines[i].split("");
                _html += '<div class="l">';
                for (var j = 0; j < chars.length; j++) {
                    _html += '<span class="w '
                    if (j == (chars.length-1) && chars[j] == ".") {
                        _html += 'last_dot';
                    }
                    _html += ' " style="animation:wordAnim ' + fadeSec + 's ease-in-out ' + delay + 's forwards;">';
                    _html += chars[j] + '</span>';
                    delay += delayInt;
                }
                _html += '</div>';
            }
            el.find("h2").html(_html).css("opacity","1");
    }
}
            function writeChars(p, t, lim) {

                //CONTROL VALUES
                var charWidth = 1;
                  var spaceWidth = 15;
                  var animSpeed = 3;
                  var fadeSec = 2;
                  var lineSpace = 64;
				// if (window.innerWidth < 749) {
				// 	lineSpace = 40;
				// }

                var zone = document.getElementById(p);
                var width = 0;
                var top = 0;
                // console.log(zone);
                var chars = t.split(" ");
                for (var i = 0; i < chars.length; i++) {
                    if (i > 0) {
                        width += spaceWidth;
                    }
                    var s = "<span id ='" + p + "char" + i +
                            "' class='writer' style='top:" + top + "px; left:" + width +
                            "px;animation:charAnim " + fadeSec + "s ease-in-out " + i/animSpeed + "s forwards;'>"
                            + chars[i] + "</span>";
                    var node = document.createElement("div");
                    node.innerHTML = s;
                    zone.appendChild(node);
                    var blah = document.getElementById(p + "char" + i);

                    if (blah.offsetWidth == 0) {
                        width += spaceWidth;
                    }
                    else {
                        width += blah.offsetWidth+charWidth;
                    }
                    console.log(lim);
                    console.log(width);
                    if (width >= lim) {
                        width = -15;
                        top += lineSpace;
                    }

                }
                // setTimeout(function() {
                    zone.style.height = (top+45) + "px";
                // }, 100);

            }

            /*
            sliderItem.find('.bullet').on('click', (e) => {
                let sliderItemIndex = $(e.currentTarget).parents('.owl-item').index();
                slider.trigger('to.owl.carousel', sliderItemIndex);
            })*/

        };

    module.init = init;

    return module;

};

export default sliderSlick();
